import React, { useCallback } from 'react';
import { PageSection, pdpSectionStyle } from 'common/components/page-section';
import { Characteristic, getCharacteristics } from 'features/product-info';
import { useSelector } from 'react-redux';
import { analyticsUtils, jc } from 'utils';
import { getSectionMeta } from 'features/page-navigation/ducks/selectors';
import { Sections } from 'features/page-navigation/components/section-refs-context';
import { Typography } from 'fronton-react';
import { sectionHeadTitle } from 'features/styles';
import { List, ListItem } from './list';

export const DATA_QA_PDP_C14S_SECTION = 'pdp-c14s-section';

export type Props = React.HTMLAttributes<HTMLElement> & {
  onCollapsedToggle: (cancelAnimations?: boolean) => void;
};

const getC14sSectionMeta = getSectionMeta('c14s');

export const Characteristics: React.FC<Props> = ({ id, className, onCollapsedToggle }) => {
  const sectionMeta = useSelector(getC14sSectionMeta);
  const characteristics = useSelector(getCharacteristics);

  const ref = React.useContext(Sections.Context).get('characteristics');

  const sendAnalytics = useCallback((isFade: boolean) => {
    analyticsUtils.sendEvent('GA:clickButton', {
      elementBlock: 'productDetail',
      elementName: `characteristics / ${isFade ? 'close' : 'open'}`,
      elementText: 'Характеристики',
      elementType: 'button',
    });
  }, []);

  if (sectionMeta) {
    return (
      <section
        id={id || sectionMeta.navigationId}
        className={jc(pdpSectionStyle, className || '')}
        data-qa={DATA_QA_PDP_C14S_SECTION}
      >
        <PageSection
          onSendAnalytics={sendAnalytics}
          sectionLocation="c14s"
          variant="v-limited"
          onCollapsedToggle={onCollapsedToggle}
          headline={
            <Typography
              className={sectionHeadTitle}
              ref={ref as React.Ref<HTMLHeadingElement>}
              as="h2"
              variant="h2"
            >
              {sectionMeta.title}
            </Typography>
          }
        >
          <List>
            {characteristics?.map(({ key, value, description }: Characteristic) => (
              <ListItem key={key} attribute={key} value={value} description={description} />
            ))}
          </List>
        </PageSection>
      </section>
    );
  }
  return null;
};
